import React from 'react';
import { CheckoutViewProps } from './CheckoutTypes';
import CheckoutForms from './checkout_forms';
import '../../../../sass/apps/commerce/forms/inline_checkout.scss';

export default function InlineCheckout(props: CheckoutViewProps) {
  return (
    <div
      className={`inline-payment${
        props.upgradeContext != 'contact_advertiser'
          ? ' inline-payment--shallow-top'
          : ''
      }`}
    >
      <div className="inline-payment__header">
        <h4 className="inline-payment__heading">
          {props.upgradeContext == 'contact_advertiser' ? '3. ' : '2. '}
          {props.localisations.enter_card_details}
        </h4>
        <span className="inline-payment__secure">
          <i className="far fa-lock-alt"></i> {props.localisations.pay_securely}
        </span>
      </div>
      <div className="inline-payment__options">
        <CheckoutForms {...props} inlinePayment={true} stripeLabelText={''} />
      </div>
    </div>
  );
}
